(async () => {

  if (!customElements.get('featured-collection-swiper')) {

    const Swiper = (await import('swiper')).default;
    const { Autoplay, Navigation, Pagination, Scrollbar } = await import('swiper/modules');

    // Modules are now included in the Swiper constructor options

    class FeaturedCollection extends HTMLElement {
      constructor() {
        super();
        this.swiperElement = this.querySelector('[data-swiper-featured-collection]');
        this.swiperOptions = {
          modules: [Navigation, Pagination, Scrollbar, Autoplay],
          loop: false,
          autoplay: false,
          slidesPerView: 1,
          spaceBetween: 16,
          threshold: 10,
          direction: 'horizontal',
          centerInsufficientSlides: true,
          breakpoints: {
            480: {
              slidesPerView: 2
            },
            768: {
              slidesPerView: 3.5
            },
            1024: {
              slidesPerView: 5
            },
            1440: {
              slidesPerView: 6
            }
          },
        }

        // Check if we have extra options on the HTML
        if (this && this.dataset && this.dataset.options) {
          const jsonOptions = JSON.parse(this.dataset.options);
          if (jsonOptions) {
            this.swiperOptions = {
              ...this.swiperOptions,
              ...jsonOptions
            };
          }
        }

        // re-init slider when Theme Editor is active
        if (Shopify.designMode && this.swiperInstance) {
          window.addEventListener('shopify:section:load', () => {
            this.swiperInstance.update();
          });
        }
        this.init();
      }

      init() {
        this.swiperInstance = new Swiper(this.swiperElement, this.swiperOptions);
      }

    }

    window.FeaturedCollection = FeaturedCollection;

    customElements.define('featured-collection-swiper', FeaturedCollection);

  }

})();
